import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  ControlContainer,
  FormBuilder,
} from "@angular/forms";
import { ColumnMode, DatatableComponent } from "@swimlane/ngx-datatable";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { Subscription } from "rxjs";
import { CurrencyPipe } from "@angular/common";

@Component({
  selector: "app-modale-dati-contabili",
  templateUrl: "./modale-dati-contabili.component.html",
})
export class ModaleDatiContabiliComponent implements OnInit, OnDestroy {
  private config = {
    class: "modal-dialog modal-info modal-lg",
    animated: true,
  };

  public modalRef: BsModalRef;
  public contoSearch: string;
  @ViewChild("templateModaleDatiContabili", { static: false })
  public modaleDatiContabili: TemplateRef<any>;
  @ViewChild("myTable", { static: false })
  public myTable: DatatableComponent;
  @Output()
  emettiDatiContabiliSelected: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();
  ColumnMode = ColumnMode;
  expanded: any = {};
  //per modale
  titolo: string;
  testo: string;
  messages = {
    emptyMessage: "Nessun conto",
    totalMessage: "totali",
  };

  private utenteSubscription: Subscription;

  public parentForm;
  constructor(
    private modalService: BsModalService,
    private fb: FormBuilder,
    private parentControl: ControlContainer,
    private currencyPipe: CurrencyPipe
  ) { }

  ngOnInit() {
    this.parentForm = this.parentControl.control.get(
      "completaDatiContabiliForm"
    );
  }

  isImportoMinoreDiResiduo(importo: string, residuo: string): boolean {
    // Sostituisci la virgola con un punto
    const residuoNormalizzato = residuo.replace(",", ".");
    const importoNormalizzato = importo.replace(",", ".");

    try {
      const currencyValue = this.currencyPipe.transform(
        importo,
        "EUR",
        true,
        "1.2-2",
        "it-IT"
      )
      if (currencyValue == null) {
        return false;
      }
    } catch (e) {
      console.log("[isImportoMinoreDiResiduo] errore in currency pipe")
      return false;
    }


    // Converti le stringhe in numeri
    const numResiduo = parseFloat(residuoNormalizzato);
    const numImporto = parseFloat(importoNormalizzato);

    // Controlla se i valori sono numeri validi
    if (isNaN(numResiduo) || isNaN(numImporto)) {
      console.log("[isImportoMinoreDiResiduo] dati non validi");
      return false
    }

    // Confronta i valori
    console.log("[isImportoMinoreDiResiduo] confronto residuo: ", numResiduo, " numImport:  ", numImporto);

    console.log("[isImportoMinoreDiResiduo] result: ", numImporto <= numResiduo);

    return numImporto <= numResiduo;
  }

  disabledBtn(): boolean {
    if (
      this.parentForm.get("importo").value &&
      this.isImportoMinoreDiResiduo(
        this.parentForm.get("importo").value,
        this.parentForm.get("residuo").value
      ) &&
      this.parentForm.valid
    ) {
      return false;
    }
    return true;
  }

  openModal() {
    this.modalRef = this.modalService.show(
      this.modaleDatiContabili,
      this.config
    );
  }

  formattaImporto() {
    let importoDaFormattare = this.parentForm
      .get("importo")
      .value.replace(",", ".");
    let indexPunto = 0;
    let importoFormattato;
    if (importoDaFormattare.substring("0") === ".") {
      importoDaFormattare = "0" + importoDaFormattare;
    }
    if (importoDaFormattare.indexOf(".") > 0) {
      indexPunto = importoDaFormattare.indexOf(".");
    }
    if (indexPunto > 0) {
      importoFormattato = importoDaFormattare.substring(0, indexPunto + 3);
    } else {
      importoFormattato = importoDaFormattare;
    }

    this.parentForm.get("importo").setValue(importoFormattato);
  }

  ngOnDestroy(): void {
    if (this.utenteSubscription) {
      this.utenteSubscription.unsubscribe();
    }
  }

  aggiungiDatiContabili() {
    this.emettiDatiContabiliSelected.emit(true);
    this.modalRef.hide();
  }
}
